/** Termini di ricerca corretti, usati per proporre un suggerimento quando l'utente digita un termine simile ma errato */
/*Metodo usato per individuarli:

- estrazione tramite graphql di tutti i prodotti nwel website 24orepro. 
  NON è stato fatto il check di esistenza in categorie per cui alcune parole potrebbero comunque non generare risultati (es. Vino&finanza). 
- individuazione (con match case insensitive) delle parole singole che contengono lettere, numeri e/o caratteri speciali compresi tra + - ! ? & /
- aggiunta di espressioni custom come Norme&Tributi, Book24 (che ha più matching con eventuali ricerche rispetto al termine Book24Ore)

Per aggiungere i termini dei nuovi prodotti lanciare a mano `yarn generate-search-terms` e committare il file aggiornato
(vedi scripts/generateSearchTerms.js: i termini esistenti mantengono la priorità, i nuovi vengono aggiunti con priorità 1).

Con 1366 parole il matching  cuba mediamente 1.23 millisecondi utilizzando l'algoritmo attualmente implementato.


Il numero accanto qalla chiave indica la priorità. Più il numero è alto maggiore sarà la sua priorità nei suggerimenti in caso di più parole con la stessa distanza di Levenshtein.
Ad esempio "giud" ha distanza 2 sia da "gold" che da "guida", ma la parola da suggerire è "guida", per cui alziamo la priorità a "guida"

*/
export const CORRECT_SEARCH_TERMS = {
  "770": 1,
  "2023": 1,
  "2026": 1,
  "Percorso": 1,
  "Lavoro": 2,
  "Approfondimento": 1,
  "Modulo24": 1,
  "Tributi": 1,
  "Guida": 1,
  "Fisco": 1,
  "Norme": 1,
  "Digitale": 1,
  "Smart24": 1,
  "Collaboratori": 1,
  "Corsi": 1,
  "Sole": 1,
  "Ore": 1,
  "Fiscale": 1,
  "Master": 1,
  "Quotidiano": 1,
  "Diritto": 1,
  "Seminari": 1,
  "Valore24": 1,
  "Dipendenti": 1,
  "Tutto": 1,
  "Sito": 1,
  "Professionale": 1,
  "Gestione": 1,
  "Laboratorio": 1,
  "Riforma": 1,
  "Book24ore": 1,
  "Book24": 1,
  "Enti": 1,
  "Locali": 1,
  "Impresa": 1,
  "Bilancio": 1,
  "Pratica": 1,
  "Settore": 1,
  "Società": 1,
  "Iva": 1,
  "Terzo": 1,
  "Condominio": 1,
  "Nt+": 1,
  "Sessioni": 1,
  "Codice": 1,
  "Lex": 1,
  "Operazioni": 1,
  "Disciplina": 1,
  "Quesiti": 1,
  "Fiscalità": 1,
  "Digital": 1,
  "Redditi": 1,
  "Immobili": 1,
  "Contabilità": 1,
  "Crisi": 1,
  "Accertamento": 1,
  "Riscossione": 1,
  "Contenzioso": 1,
  "Manuali": 1,
  "Frizzera": 1,
  "Imprese": 1,
  "Telefisco": 1,
  "Novità": 1,
  "Edizione": 1,
  "Acquisto": 1,
  "Risponde": 1,
  "Servizio": 1,
  "Punto": 1,
  "Edilizia": 1,
  "Certificato": 1,
  "Guide": 1,
  "Adempimenti": 1,
  "Annuale": 1,
  "Pratiche": 1,
  "Contratti": 1,
  "Carta": 1,
  "Nuovo": 1,
  "Straordinarie": 1,
  "Dopo": 1,
  "Persone": 1,
  "Immobiliare": 1,
  "Aggiornamento": 1,
  "Aspenia": 1,
  "Top24": 1,
  "Analisi": 1,
  "Fiscali": 1,
  "Report": 1,
  "Internazionale": 1,
  "Principali": 1,
  "Dichiarazione": 1,
  "Seminario": 1,
  "Responsabilità": 1,
  "Modulo": 1,
  "Sostenibilità": 1,
  "Domenica": 1,
  "Libri": 1,
  "Compliance": 1,
  "Penale": 1,
  "Transizione": 1,
  "Azienda": 1,
  "Legale": 1,
  "Operative": 1,
  "Strumenti": 1,
  "Sport": 1,
  "Canone": 1,
  "Appalti": 1,
  "All": 1,
  "Nuova": 1,
  "Tributaria": 1,
  "Formazione": 1,
  "Esg": 1,
  "Contabili": 1,
  "Casistiche": 1,
  "Cooperative": 1,
  "Fascicoli": 1,
  "Settimana": 1,
  "Come": 1,
  "Mensile": 1,
  "Intelligenza": 1,
  "Reddito": 1,
  "Rassegna": 1,
  "Italyx": 1,
  "Privacy": 1,
  "Tributario": 1,
  "Archivio": 1,
  "Consulente": 1,
  "Tassazione": 1,
  "Civile": 1,
  "Casi": 1,
  "Tecnici": 1,
  "Pubblici": 1,
  "Artificiale": 1,
  "Corso": 1,
  "Revisione": 1,
  "Sanzioni": 1,
  "Patrimonio": 1,
  "Controlli": 1,
  "Antiriciclaggio": 1,
  "Modello": 1,
  "Business": 1,
  "Pubblico": 1,
  "Unico": 1,
  "Rischi": 1,
  "Studio": 1,
  "Fisiche": 1,
  "Pensioni": 1,
  "Imu": 1,
  "Estero": 1,
  "Imposta": 1,
  "Cloud": 1,
  "Trust": 1,
  "Protezione": 1,
  "Regime": 1,
  "Famiglia": 1,
  "Esperto": 1,
  "Start": 1,
  "Avviamento": 1,
  "Inquadramento": 1,
  "Attualità": 1,
  "Wealth": 1,
  "Planning": 1,
  "Laboratori": 1,
  "Cartacea": 1,
  "Energia": 1,
  "Pratici": 1,
  "Più": 1,
  "Rapporto": 1,
  "Journalism": 1,
  "Abbonamento": 1,
  "Casa": 1,
  "Attività": 1,
  "Esercizio": 1,
  "Avanzato": 1,
  "Ricorrenti": 1,
  "Determinazione": 1,
  "Plan": 1,
  "Risarcimento": 1,
  "Operatori": 1,
  "Processo": 1,
  "Rendicontazione": 1,
  "Agevolazioni": 1,
  "Amministrativa": 1,
  "Sportivi": 1,
  "Ets": 1,
  "Continuativo": 1,
  "Tuir": 1,
  "Formativi": 1,
  "24+": 1,
  "Versione": 1,
  "Campagna": 1,
  "Testo": 1,
  "Imposte": 1,
  "Futuro": 1,
  "Procedura": 1,
  "Codici": 1,
  "Prontuario": 1,
  "Bonus": 1,
  "Ccnl": 1,
  "Comparto": 1,
  "Funzioni": 1,
  "Manuale": 1,
  "Mente": 1,
  "Contributi": 1,
  "Primo": 1,
  "Data": 1,
  "Bim": 1,
  "Paghe": 1,
  "Blockchain": 1,
  "Crediti": 1,
  "All-inclusive": 1,
  "V24": 1,
  "Aziendale": 1,
  "Scelta": 1,
  "Sociali": 1,
  "Strutture": 1,
  "Pianificazione": 1,
  "Professionali": 1,
  "Locazioni": 1,
  "Due": 1,
  "Utilizzo": 1,
  "Potere": 1,
  "Settembre": 1,
  "Previdenza": 1,
  "Tools": 1,
  "Energetica": 1,
  "Economia": 1,
  "Superbonus": 1,
  "Economici": 1,
  "Impatto": 1,
  "Redazione": 1,
  "Completo": 1,
  "Cartaceo": 1,
  "Operativo": 1,
  "Speciale": 1,
  "Esecutivo": 1,
  "Ambiente": 1,
  "Università": 1,
  "Pubblica": 1,
  "Maturità": 1,
  "Esame": 1,
  "Leggi": 1,
  "Complementari": 1,
  "Compilazione": 1,
  "Valore": 1,
  "Piccolo": 1,
  "Agricoltura": 1,
  "Visual": 1,
  "Storytelling": 1,
  "Brevi": 1,
  "Pacchetto": 1,
  "Errori": 1,
  "Normative": 1,
  "Contratto": 1,
  "Collegio": 1,
  "Sindacale": 1,
  "Certificazione": 1,
  "Produzione": 1,
  "Profili": 1,
  "Sicurezza": 1,
  "Preventivi": 1,
  "Ravvedimento": 1,
  "Operoso": 1,
  "Amministrazione": 1,
  "Italia": 1,
  "Verifica": 1,
  "Dossier": 1,
  "Nuove": 1,
  "Regole": 1,
  "24ai": 1,
  "Revisore": 1,
  "Marco": 1,
  "Luglio": 1,
  "Financial": 1,
  "Reporting": 1,
  "Volontariato": 1,
  "Patrimoniale": 1,
  "Sabato": 1,
  "Fiscalita": 1,
  "Formato": 1,
  "Test": 1,
  "Sistema": 1,
  "Leadership": 1,
  "Dati": 1,
  "1/2026": 1,
  "Irpef": 1,
  "Sociale": 1,
  "Prodotto": 1,
  "Febbraio": 1,
  "Fondi": 1,
  "Incentivi": 1,
  "Rendiconto": 1,
  "Monitoraggio": 1,
  "Commerciali": 1,
  "Semplici": 1,
  "Farmaceutica": 1,
  "Specialistica": 1,
  "Auto": 1,
  "Aziende": 1,
  "Servizi": 1,
  "Dicembre": 1,
  "Sindaci": 1,
  "2/2025": 1,
  "Conservazione": 1,
  "Gdpr": 1,
  "Dogane": 1,
  "Regimi": 1,
  "Principi": 1,
  "Convenienza": 1,
  "Trattamento": 1,
  "Tutela": 1,
  "Ruolo": 1,
  "Holding": 1,
  "Studi": 1,
  "Quadro": 1,
  "Ricettive": 1,
  "Extralberghiere": 1,
  "Controllo": 1,
  "Creazione": 1,
  "Aspetti": 1,
  "Diligence": 1,
  "Doganale": 1,
  "Mediazione": 1,
  "Cessione": 1,
  "Comunicazioni": 1,
  "Irregolarità": 1,
  "Avvisi": 1,
  "Bonari": 1,
  "Soci": 1,
  "Rentri": 1,
  "Pmi": 1,
  "Strada": 1,
  "Welfare": 1,
  "Posta": 1,
  "Opportunità": 1,
  "Viaggio": 1,
  "Cartabia": 1,
  "Semestrale": 1,
  "Locale": 1,
  "Valutazione": 1,
  "Innovazione": 1,
  "Oltre": 1,
  "Turistiche": 1,
  "Light": 1,
  "Scuole": 1,
  "Superiori": 1,
  "Salva": 1,
  "Sostenibile": 1,
  "Registro": 1,
  "Professionisti": 1,
  "Ottobre": 1,
  "Rapporti": 1,
  "Nuovi": 1,
  "Perfetta": 1,
  "M&a": 1,
  "Acquisizione": 1,
  "Personale": 1,
  "Giulio": 1,
  "Andreani": 1,
  "Gabriele": 1,
  "Sepio": 1,
  "Tributarie": 1,
  "Legge": 1,
  "Mondo": 1,
  "Bilanci": 1,
  "Prima": 1,
  "Qualifica": 1,
  "Civilistico": 1,
  "Diritti": 1,
  "Parte": 1,
  "Sportivo": 1,
  "Capitali": 1,
  "Operativa": 1,
  "Tari": 1,
  "Plus24": 1,
  "Diretta": 1,
  "Trappole": 1,
  "Commercialista": 1,
  "Etica": 1,
  "Scorretti": 1,
  "Novembre": 1,
  "Centrale": 1,
  "Volumi": 1,
  "Plusvalenze": 1,
  "Immobiliari": 1,
  "Governance": 1,
  "E-commerce": 1,
  "2/2026": 1,
  "Stato": 1,
  "Storia": 1,
  "Management": 1,
  "Strategia": 1,
  "Tabelle": 1,
  "Marketing": 1,
  "Territorio": 1,
  "Pace": 1,
  "Artificiali": 1,
  "Acconto": 1,
  "Progettazione": 1,
  "Office": 1,
  "Aziende24": 1,
  "Pianeta": 1,
  "Inclusive": 1,
  "Dirette": 1,
  "Semestre": 1,
  "Ecologica": 1,
  "Mediante": 1,
  "Condominiale": 1,
  "Avvocati": 1,
  "Trasformazione": 1,
  "Edilizi": 1,
  "Food": 1,
  "Beverage": 1,
  "Colf": 1,
  "Badanti": 1,
  "4/2025": 1,
  "Bit": 1,
  "Standard": 1,
  "Tecnologie": 1,
  "Strategie": 1,
  "Sistemi": 1,
  "Nazionale": 1,
  "Dirigenti": 1,
  "Revisori": 1,
  "Previdenziale": 1,
  "Prevenzione": 1,
  "Quadri": 1,
  "Criteri": 1,
  "Costruzione": 1,
  "Tcf": 1,
  "Corretta": 1,
  "Problematiche": 1,
  "Soggetti": 1,
  "Sovraindebitamento": 1,
  "Consumatore": 1,
  "Transfer": 1,
  "Reati": 1,
  "Professionista": 1,
  "Civilistici": 1,
  "Agenzie": 1,
  "Organizzazione": 1,
  "Strategico": 1,
  "Transazione": 1,
  "Esteri": 1,
  "Adeguati": 1,
  "Assetti": 1,
  "Amministratori": 1,
  "Predisposizione": 1,
  "Commentato": 1,
  "Valutazioni": 1,
  "Whistleblowing": 1,
  "3/2025": 1,
  "Mandati": 1,
  "Documentale": 1,
  "Consulenza": 1,
  "Competenze": 1,
  "Digitali": 1,
  "Stipendio": 1,
  "Ispezioni": 1,
  "Ricorsi": 1,
  "Commercio": 1,
  "Rete": 1,
  "Familiari": 1,
  "Concordato": 1,
  "Preventivo": 1,
  "Biennale": 1,
  "Entrate": 1,
  "Istituti": 1,
  "Rsg": 1,
  "Relazione": 1,
  "Filosofia": 1,
  "Piano": 1,
  "Rivoluzione": 1,
  "Tutti": 1,
  "Ambito": 1,
  "Facile": 1,
  "Costo": 1,
  "Finanziari": 1,
  "Circolazione": 1,
  "1/2025": 1,
  "Nucleare": 1,
  "Correttivo": 1,
  "Hse": 1,
  "Tecnico": 1,
  "Polizia": 1,
  "Dipendente": 1,
  "Impositivo": 1,
  "Tax": 1,
  "Benefit": 1,
  "4/2024": 1,
  "Decreto": 1,
  "Sfide": 1,
  "Cantieri": 1,
  "Intelligenze": 1,
  "Successione": 1,
  "Trappola": 1,
  "Controdeduzioni": 1,
  "Appellato": 1,
  "Tempo": 1,
  "Cosa": 1,
  "Credito": 1,
  "Ricerca": 1,
  "2019-2021": 1,
  "Operativi": 1,
  "Coordinato": 1,
  "Design": 1,
  "Iii": 1,
  "Edilizie": 1,
  "Perizie": 1,
  "Stima": 1,
  "Ires": 1,
  "Conciliazione": 1,
  "Correlati": 1,
  "Piazza": 1,
  "Luigi": 1,
  "Lovecchio": 1,
  "Ceppellini": 1,
  "Dato": 1,
  "Paola": 1,
  "Zambon": 1,
  "Benedetto": 1,
  "Santacroce": 1,
  "Sergio": 1,
  "Pellegrino": 1,
  "Belardi": 1,
  "Alessandra": 1,
  "Caputo": 1,
  "Barbara": 1,
  "Zanardi": 1,
  "2/2024": 1,
  "Cartacei": 1,
  "Medicina": 1,
  "Quesito": 1,
  "Salvaguardia": 1,
  "Assestamento": 1,
  "Previsione": 1,
  "2025/2027": 1,
  "Apprendistato": 1,
  "Giugno": 1,
  "Finanziamento": 1,
  "Adeguamenti": 1,
  "Statutari": 1,
  "Runts": 1,
  "Edili": 1,
  "Arte": 1,
  "Labour": 1,
  "Condivisa": 1,
  "Incontri": 1,
  "Fondo": 1,
  "Raccolta": 1,
  "Fini": 1,
  "Maggio": 1,
  "Aprile": 1,
  "Marzo": 1,
  "Tributari": 1,
  "Partenariato": 1,
  "Privato": 1,
  "Esecuzione": 1,
  "Lavori": 1,
  "Anno": 1,
  "Zero": 1,
  "Csrd": 1,
  "Proposta": 1,
  "Lavoratori": 1,
  "Silver": 1,
  "Storico": 1,
  "Vincolo": 1,
  "Interni": 1,
  "Invio": 1,
  "Dichiarazioni": 1,
  "Academy": 1,
  "Firenze": 1,
  "Milano": 1,
  "Roma": 1,
  "Confronto": 1,
  "Ristrutturazione": 1,
  "Debito": 1,
  "Agosto": 1,
  "Vertenze": 1,
  "Modulistica": 1,
  "Breaking": 1,
  "News": 1,
  "Donne": 1,
  "Capitale": 1,
  "Paghetta": 1,
  "Epub": 1,
  "Informazione": 1,
  "Fabbricati": 1,
  "Terreni-cartaceo": 1,
  "Speciale-annuale": 1,
  "Pdf": 1,
  "Avvocato": 1,
  "Esperto++": 1,
  "Genius": 1,
  "Corporate": 1,
  "Integrata": 1,
  "Dentro": 1,
  "Pay": 1,
  "Transparency": 1,
  "Borse": 1,
  "Progettista": 1,
  "Opera": 1,
  "Italiana": 1,
  "Consulting": 1,
  "5/2026": 1,
  "Valutare": 1,
  "Rischio": 1,
  "Amianto": 1,
  "Manufatti": 1,
  "Aria": 1,
  "Responsabile": 1,
  "Forma": 1,
  "Associata": 1,
  "Piccoli": 1,
  "Comuni": 1,
  "Edifici": 1,
  "Autoconsumo": 1,
  "Comunità": 1,
  "Energetiche": 1,
  "4/2026": 1,
  "Temi": 1,
  "Expand": 1,
  "Separazione": 1,
  "Divorzio": 1,
  "Trend": 1,
  "Trash": 1,
  "Preventiva": 1,
  "Pef": 1,
  "Tariffe/corrispettivi": 1,
  "Mtr-3": 1,
  "Rifiuti": 1,
  "Decisioni": 1,
  "Bretton": 1,
  "Woods": 1,
  "Xxi": 1,
  "Secolo": 1,
  "Modelli": 1,
  "Infrastrutture": 1,
  "Applicazioni": 1,
  "Passaporto": 1,
  "Dpp": 1,
  "Aggiunto": 1,
  "Amori": 1,
  "Dolori": 1,
  "Commento": 1,
  "2022-2024": 1,
  "Scopo": 1,
  "Cambia": 1,
  "Rotta!": 1,
  "Sfaticati": 1,
  "Family": 1,
  "Migliori": 1,
  "Pinocchio": 1,
  "Ancora": 1,
  "Hackerare": 1,
  "3/2026": 1,
  "Formulario": 1,
  "Bioenergie": 1,
  "Biochar": 1,
  "Bollettino": 1,
  "Regione": 1,
  "Voce": 1,
  "Hai?": 1,
  "Fusione": 1,
  "Conferimento": 1,
  "Scissione": 1,
  "Liquidazione": 1,
  "Normativo": 1,
  "Personalizzato": 1,
  "Indirette": 1,
  "Trustee": 1,
  "Function": 1,
  "Point": 1,
  "Capitalizzazione": 1,
  "Software": 1,
  "Informativa": 1,
  "Affitti": 1,
  "Abitativi": 1,
  "Scadenze": 1,
  "Gdpr-small": 1,
  "Fino": 1,
  "Gdpr-base": 1,
  "Mono": 1,
  "Vendita": 1,
  "Europeo": 1,
  "Leva": 1,
  "Strategica": 1,
  "Conti": 1,
  "Cybersicurezza": 1,
  "Responsabili": 1,
  "Informatici": 1,
  "Collettivo": 1,
  "Produttrici": 1,
  "Beni": 1,
  "Gennaio": 1,
  "Piao": 1,
  "Saldo": 1,
  "Sostenibiltà": 1,
  "Rigenerativa": 1,
  "Mina": 1,
  "Infortuni": 1,
  "Rilevazioni": 1,
  "Imprenditori/professionisti": 1,
  "Compilativi": 1,
  "Dichiarativi": 1,
  "Documenti": 1,
  "Indicatori": 1,
  "Performance": 1,
  "Modalità": 1,
  "Oic": 1,
  "Vautazione": 1,
  "Poste": 1,
  "Forfettario": 1,
  "Cripto-attività": 1,
  "Gestire": 1,
  "Noi": 1,
  "Deboli": 1,
  "Pricing": 1,
  "Difesa": 1,
  "Estere": 1,
  "Esterovestizione": 1,
  "Aggregazione": 1,
  "Intracomunitarie": 1,
  "Internazionali": 1,
  "Aggressiva": 1,
  "Stabile": 1,
  "Occulta": 1,
  "Elusivi": 1,
  "Branch": 1,
  "Exemption": 1,
  "Dividendi": 1,
  "Paradisiaci": 1,
  "Strumento": 1,
  "Trasparenza": 1,
  "Accountability": 1,
  "Rw": 1,
  "Cfc": 1,
  "Luce": 1,
  "Modifiche": 1,
  "Composizione": 1,
  "Negoziata": 1,
  "Successorie": 1,
  "Passaggio": 1,
  "Generazionale": 1,
  "Breve": 1,
  "Organizzativi": 1,
  "Doveri": 1,
  "Finanziario": 1,
  "Gruppo": 1,
  "Conferimenti": 1,
  "Partecipazioni": 1,
  "Influencer": 1,
  "Content": 1,
  "Creator": 1,
  "Banca-impresa": 1,
  "Banche": 1,
  "Leggono": 1,
  "Finanziaria": 1,
  "Atlante": 1,
  "Complessità": 1,
  "Elementi": 1,
  "Antincendio": 1,
  "Quando": 1,
  "Parla": 1,
  "Product": 1,
  "Passport": 1,
  "Commerciale": 1,
  "Rimanenze": 1,
  "Magazzino": 1,
  "Diffusioni": 1,
  "Pubblicitarie": 1,
  "Occupazioni": 1,
  "Suolo": 1,
  "Salute": 1,
  "Rinunce": 1,
  "Transazioni": 1,
  "Conciliazioni": 1,
  "Innovativa": 1,
  "Metalmeccanica": 1,
  "Pignoramenti": 1,
  "Quinto": 1,
  "Affrontare": 1,
  "Turismo": 1,
  "Religiosi": 1,
  "Morali": 1,
  "Fism": 1,
  "Spedizione": 1,
  "Trasporto": 1,
  "Merci": 1,
  "Collettivi": 1,
  "Coesione": 1,
  "Stranieri": 1,
  "Expating": 1,
  "Italiano": 1,
  "Fuori": 1,
  "Sede": 1,
  "Itinerante": 1,
  "Trasferte": 1,
  "Distacchi": 1,
  "Autonomi": 1,
  "Subordinati": 1,
  "Spettacolo": 1,
  "Perdite": 1,
  "Ambientale": 1,
  "6/2025": 1,
  "Piattaforme": 1,
  "Pdnd": 1,
  "Pnd": 1,
  "Amministrazioni": 1,
  "Pubbliche": 1,
  "Autonomo": 1,
  "Cosmesi": 1,
  "Coattiva": 1,
  "Travel": 1,
  "Entertainment": 1,
  "Successoria": 1,
  "Top4": 1,
  "Deflativi": 1,
  "Sanita": 1,
  "Decarbonizzazione": 1,
  "Abilitatori": 1,
  "Innovative": 1,
  "Sirene": 1,
  "Valorizzare": 1,
  "Diversità": 1,
  "Genere": 1,
  "Buone": 1,
  "Criticità": 1,
  "Indicazioni": 1,
  "Finanza": 1,
  "Amore": 1,
  "5/2025": 1,
  "Triennale": 1,
  "Informatica": 1,
  "2024-2026": 1,
  "Longevità": 1,
  "Armonia": 1,
  "Agevolata": 1,
  "Figura": 1,
  "Ufficiale": 1,
  "Cup": 1,
  "Fattori": 1,
  "Center": 1,
  "Pressione": 1,
  "Sotto": 1,
  "Building": 1,
  "Infrastructure": 1,
  "Fashion": 1,
  "Industry": 1,
  "Canoni": 1,
  "Contesto": 1,
  "Dominio": 1,
  "Elonomics": 1,
  "Disordine": 1,
  "Soffitti": 1,
  "Cristallo": 1,
  "Radici": 1,
  "Acciaio": 1,
  "Pensiero": 1,
  "Conta": 1,
  "Scritture": 1,
  "Profiling": 1,
  "Pesatura": 1,
  "Indennità": 1,
  "Posizione": 1,
  "Metodologia": 1,
  "Indici": 1,
  "Partecipare": 1,
  "Gara": 1,
  "Shopping": 1,
  "Infinito": 1,
  "Giovani": 1,
  "Talenti": 1,
  "Fallimento": 1,
  "Visite": 1,
  "Ispettive": 1,
  "Patente": 1,
  "Gpf": 1,
  "Score": 1,
  "Tecniche": 1,
  "Cndcec": 1,
  "Terza": 1,
  "Età": 1,
  "Teoria": 1,
  "Sex": 1,
  "Economy": 1,
  "Report+": 1,
  "Urbanistica": 1,
  "Desk24": 1,
  "Ufficio": 1,
  "Services": 1,
  "Correttivi": 1,
  "Metriche": 1,
  "Secondo": 1,
  "Principio": 1,
  "Vsme": 1,
  "Efrag": 1,
  "Motivazione": 1,
  "Fattore": 1,
  "Impatriati": 1,
  "Verifiche": 1,
  "Tema": 1,
  "Price": 1,
  "Lotta": 1,
  "Paradisi": 1,
  "Novita": 1,
  "Difensore": 1,
  "Civico": 1,
  "Collana": 1,
  "Tematiche": 1,
  "Integrità": 1,
  "Irpef/ires": 1,
  "Eroine": 1,
  "Libertà": 1,
  "Giudice": 1,
  "Control": 1,
  "Framework": 1,
  "Difendere": 1,
  "Cyber-crime": 1,
  "Minacce": 1,
  "Tecnologiche": 1,
  "Vie": 1,
  "Ente": 1,
  "Bene": 1,
  "Sfida": 1,
  "Green": 1,
  "Contraddizioni": 1,
  "Circolare": 1,
  "Temporanei": 1,
  "Mobili": 1,
  "Lavoro-posta": 1,
  "Poteri": 1,
  "Segnalazioni": 1,
  "Facoltà": 1,
  "Investigative": 1,
  "Interne": 1,
  "Prepararsi": 1,
  "Ritorno": 1,
  "Algoritmo": 1,
  "Criminale": 1,
  "Esecuzioni": 1,
  "Carta-posta": 1,
  "Donazione": 1,
  "Bordo": 1,
  "Diario": 1,
  "Salvataggio": 1,
  "Orizzonti": 1,
  "Giorgio": 1,
  "Armani": 1,
  "Appello": 1,
  "Incidentale": 1,
  "Lettera": 1,
  "Assunzione": 1,
  "Lavoratore": 1,
  "Disabile": 1,
  "Subordinato": 1,
  "Indeterminato": 1,
  "Calcolo": 1,
  "Tfr": 1,
  "Interessi": 1,
  "Legali": 1,
  "Rivalutazione": 1,
  "Costi": 1,
  "Autovetture": 1,
  "Pfas": 1,
  "Sono": 1,
  "Fare": 1,
  "Carriera": 1,
  "Draghi": 1,
  "Documento": 1,
  "Competitività": 1,
  "Europea": 1,
  "3/2024": 1,
  "Altro": 1,
  "Zio": 1,
  "Sam": 1,
  "Lezione": 1,
  "Finita": 1,
  "Sanatoria": 1,
  "Sviluppo": 1,
  "Rilevanza": 1,
  "Economica": 1,
  "Segretari": 1,
  "Comunali": 1,
  "Provinciali": 1,
  "Contabile": 1,
  "Considerare": 1,
  "Legal": 1,
  "Questo": 1,
  "Patto": 1,
  "Acquisti": 1,
  "Retepa": 1,
  "Mepa": 1,
  "Machinery": 1,
  "Mechanics": 1,
  "Silenzio": 1,
  "Bussola": 1,
  "Matricole": 1,
  "Svolgimento": 1,
  "Percorsi": 1,
  "Cessioni": 1,
  "Approfondimentoc": 1,
  "Interna": 1,
  "Ctu": 1,
  "Parità": 1,
  "Conservatori": 1,
  "Accademie": 1,
  "Social": 1,
  "Presso": 1,
  "Cliente": 1,
  "Associazioni": 1,
  "Imprenditori": 1,
  "Individuali": 1,
  "Fringe": 1,
  "Violazioni": 1,
  "Trasmissione": 1,
  "Posto": 1,
  "Giochi": 1,
  "Guerra": 1,
  "Polo": 1,
  "Via": 1,
  "Note": 1,
  "Variazione": 1,
  "Prove": 1,
  "Accesso": 1,
  "Compagnie": 1,
  "Assicurazione": 1,
  "Cose": 1,
  "Succedono": 1,
  "Vivendo": 1,
  "Monocratica": 1,
  "Trovi": 1,
  "Disegna": 1,
  "Tua": 1,
  "Eroe": 1,
  "Europa": 1,
  "Evitare": 1,
  "Declino": 1,
  "Flessibili": 1,
  "Atipici": 1,
  "Soluzioni": 1,
  "Difensivi": 1,
  "Orario": 1,
  "Minori": 1,
  "Tirocini": 1,
  "Flessibilità": 1,
  "Materia": 1,
  "Recenti": 1,
  "Evoluzioni": 1,
  "Giurisprudenziali": 1,
  "Mamme": 1,
  "Abracadabra": 1,
  "Euro": 1,
  "Tassi": 1,
  "Bce": 1,
  "Adempimento": 1,
  "Collaborativo": 1,
  "Aggiornata": 1,
  "Microcosmi": 1,
  "Comprami": 1,
  "Mai": 1,
  "Vista": 1,
  "Dotati": 1,
  "Doppia": 1,
  "Fonti": 1,
  "Statuto": 1,
  "Contribuente": 1,
  "Piccole": 1,
  "Medie": 1,
  "Gold": 1,
  "1/2024": 1,
  "Crescere": 1,
  "Corsa": 1,
  "Luna": 1,
  "Custodi": 1,
  "Delegati": 1,
  "Vendite": 1,
  "Procedimento": 1,
  "Disciplinare": 1,
  "Contestazione": 1,
  "Addebito": 1,
  "Sanzione": 1,
  "Salario": 1,
  "Accessorio": 1,
  "Costituzione": 1,
  "-la": 1,
  "Reclutamento": 1,
  "Conclusione": 1,
  "Previdenziali": 1,
  "Budget": 1,
  "Global": 1,
  "Minimun": 1,
  "Pillar": 1,
  "-trust": 1,
  "Esports": 1,
  "Gaming": 1,
  "Pubblicitario": 1,
  "Dilettantistici": 1,
  "Ridisegnare": 1,
  "Governare": 1,
  "Crescita": 1,
  "Lingua": 1,
  "Oscura": 1,
  "Regolazione": 1,
  "Ristrutturazioni": 1,
  "730/2024": 1,
  "Variazioni": 1,
  "Documentazione": 1,
  "Enc": 1,
  "Semplice": 1,
  "Biden": 1,
  "Subappalto": 1,
  "36/2023": 1,
  "Fase": 1,
  "2024+": 1,
  "Organismo": 1,
  "Vigilanza": 1,
  "Organizzazioni": 1,
  "Vorrei": 1,
  "Riversamento": 1,
  "Csdd": 1,
  "Computo": 1,
  "Manovra": 1,
  "Pnrr": 1,
  "Stazioni": 1,
  "Appaltanti": 1,
  "Scrivo": 1,
  "Ergo": 1,
  "Sum": 1,
  "Autoveicoli": 1,
  "Scioglimento": 1,
  "Atto": 1,
  "Autorità": 1,
  "Sitopay": 1,
  "Superficie": 1,
  "Socrate": 1,
  "Permanent": 1,
  "Capital": 1,
  "Wellbeing": 1,
  "Reale": 1,
  "Titolare": 1,
  "Effettivo": 1,
  "Forte": 1,
  "Chiaro": 1,
  "3/2023": 1,
  "Bronze": 1,
  "Csddd": 1,
  "Magistrato": 1,
  "Lgs": 1,
  "Responsabilita": 1,
  "Amministrazine": 1,
  "Coprogrammazione": 1,
  "Coprogettazione": 1,
  "Raccordo": 1,
  "Riforme": 1,
  "Abolizione": 1,
  "Coop": 1,
  "Quale": 1,
  "Democrazia?": 1,
  "Specialiseminari": 1,
  "Onlus": 1,
  "Loro": 1,
  "Possibile": 1,
  "Speciali": 1,
  "Indiretta": 1,
  "Erogazioni": 1,
  "Liberali": 1,
  "Denaro": 1,
  "Natura": 1,
  "Mille": 1,
  "Obblighi": 1,
  "Regolamentazione": 1,
  "Finanziamenti": 1,
  "Europei": 1,
  "Omaggi": 1,
  "Spese": 1,
  "Rappresentanza": 1,
  "Ultimi": 1,
  "Relative": 1,
  "Periodod": 1,
  "Chiusura": 1,
  "Condomini": 1,
  "Fattispecie": 1,
  "Consulenziale": 1,
  "Opposizione": 1,
  "Atti": 1,
  "Forzata": 1,
  "Viaggi": 1,
  "Vol": 1,
  "Berlusconi": 1,
  "Busta": 1,
  "Paga": 1,
  "Finanziarie": 1,
  "Certificati": 1,
  "Sara": 1,
  "Agostini": 1,
  "Deposito": 1,
  "Rendiconti": 1,
  "Schemi": 1,
  "Criptoattività": 1,
  "Rappresentazione": 1,
  "Aiuti": 1,
  "Correzione": 1,
  "Negozio": 1,
  "Fiduciario": 1,
  "Polizze": 1,
  "Assicurative": 1,
  "Destinazione": 1,
  "Debiti": 1,
  "Imprenditore": 1,
  "Accordi": 1,
  "Erariale": 1,
  "Stendhal": 1,
  "Bicicletta": 1,
  "B&b": 1,
  "Prassi": 1,
  "Periodo": 1,
  "Estivo": 1,
  "Elettronico": 1,
  "Distribuzione": 1,
  "Utili": 1,
  "Sportive": 1,
  "-terzo": 1,
  "Rendincontazione": 1,
  "5xmille": 1,
  "Ritorni": 1,
  "2/2023": 1,
  "Prova": 1,
  "Capire": 1,
  "Solo": 1,
  "Investitore": 1,
  "Consapevole": 1,
  "Bancario": 1,
  "Investire": 1,
  "Dac6": 1,
  "Soggiorno": 1,
  "Esiste": 1,
  "Successioni": 1,
  "Gioventù": 1,
  "Bloccata": 1,
  "Basic": 1,
  "Terre": 1,
  "Mezzo": 1,
  "Conf": 1,
  "Tematico": 1,
  "Singolo": 1,
  "Argomento": 1,
  "Assicurazioni": 1,
  "Profit": 1,
  "Cuore": 1,
  "Tolc": 1,
  "Attuazione": 1,
  "Vino&finanza": 1,
  "Elettrica": 1,
  "Studiare": 1,
  "Caso": 1,
  "Comunicare": 1,
  "Scienza": 1,
  "Parole": 1,
  "Mese": 1,
  "Esistenti": 1,
  "Muratura": 1,
  "Zona": 1,
  "Sismica": 1,
  "Cyber": 1,
  "Influence": 1,
  "Liquida": 1,
  "Chi": 1,
  "Curerà": 1,
  "Lavoro-annuale": 1,
  "Indagini": 1,
  "Preliminari": 1,
  "Spettatore": 1,
  "Estremo": 1,
  "Occidente": 1,
  "Decentralizzato": 1,
  "Nft": 1,
  "Metaverso": 1,
  "Inclusiva": 1,
  "Detto": 1,
  "Cinese": 1,
  "Inflazione": 1,
  "Vino": 1,
  "Rinnovi": 1,
  "Zaino": 1,
  "Omaggio": 1,
  "Nfr": 1,
  "Soluzione": 1,
  "Impiego": 1,
  "Risorsa": 1,
  "Umana": 1,
  "Elettrico": 1,
  "Esperto++risponde": 1,
  "Information": 1,
  "Technology": 1,
  "M24": 1,
  "Mercati+": 1,
  "Aspenia-carta": 1,
  "People": 1,
  "Growth": 1,
  "Fintech+": 1,
  "Real": 1,
  "Estate+": 1,
  "Raffaello": 1,
  "Pugnalato": 1,
  "Fabbriche": 1,
  "Costruirono": 1,
  "Vittoriose": 1,
  "Gratitudine": 1,
  "Meravigliose": 1,
  "Benchmark": 1,
  "Sanità": 1,
  "Agrisole": 1,
  "Agroalimentare": 1,
  "Realestate+": 1,
  "Newsletter": 1,
  "Dedicata": 1,
  "Singola": 1,
  "Norme&Tributi": 1,
  "2022-2023": 1,
  "Adattative": 1,
  "Advanced": 1,
  "Ambientalmente": 1,
  "Anni": 1,
  "Area": 1,
  "Base": 1,
  "Bici": 1,
  "Bollo": 1,
  "Bonifica": 1,
  "Bravo": 1,
  "Breviario": 1,
  "Brexit": 1,
  "Calcio": 1,
  "Cambiando": 1,
  "Capo": 1,
  "Care": 1,
  "Cattivo": 1,
  "Ceo": 1,
  "Chiamo": 1,
  "Cicli": 1,
  "Cigni": 1,
  "Città": 1,
  "Collo": 1,
  "Colombe": 1,
  "Comandare": 1,
  "Completa": 1,
  "Compravendita": 1,
  "Compromesso": 1,
  "Contrasto": 1,
  "Corrispettivi": 1,
  "Covid-19": 1,
  "Crisis": 1,
  "Cura": 1,
  "Cyberumanesimo": 1,
  "Dad": 1,
  "Dante": 1,
  "Dare": 1,
  "Deal": 1,
  "Debitore": 1,
  "Debora": 1,
  "Democrazia": 1,
  "Democrazie": 1,
  "Desprez": 1,
  "Didattica": 1,
  "Difficili": 1,
  "Distanza": 1,
  "Dodici": 1,
  "Dostoevskij": 1,
  "Eleganza": 1,
  "Emergenza": 1,
  "Emicrania": 1,
  "Emozioni": 1,
  "Eow": 1,
  "Erede": 1,
  "Eredità": 1,
  "Estate": 1,
  "Factor": 1,
  "Fai": 1,
  "Falchi": 1,
  "Felice": 1,
  "Felici": 1,
  "Felicità": 1,
  "Fiducia": 1,
  "Filler": 1,
  "Fintech": 1,
  "Fiumi": 1,
  "Galleria": 1,
  "Gas": 1,
  "Generazione": 1,
  "Giorni": 1,
  "Giorno": 1,
  "Greta": 1,
  "Hi-tech": 1,
  "Identikit": 1,
  "Indipendente": 1,
  "Inquilini": 1,
  "Internazionalizzazione": 1,
  "Isole": 1,
  "Istruzioni": 1,
  "Italiani": 1,
  "Josquin": 1,
  "Livello": 1,
  "Lockdown": 1,
  "Manager": 1,
  "Mangia": 1,
  "Maradona": 1,
  "Matematici": 1,
  "Mercati": 1,
  "Mete": 1,
  "Mida": 1,
  "Misura": 1,
  "Misure": 1,
  "Momenti": 1,
  "Morosità": 1,
  "Musica": 1,
  "Napoleone": 1,
  "Nera": 1,
  "Offerta": 1,
  "Onda": 1,
  "Online": 1,
  "Ora": 1,
  "Organizzative": 1,
  "Pandemia": 1,
  "Pandemie": 1,
  "Pandexit": 1,
  "Papà": 1,
  "Parli": 1,
  "Pensione": 1,
  "Pietra": 1,
  "Placemaking": 1,
  "Platone": 1,
  "Plus": 1,
  "Pop": 1,
  "Premium": 1,
  "Presidenti": 1,
  "Pro": 1,
  "Profilo": 1,
  "Progetto": 1,
  "Project": 1,
  "Proprietari": 1,
  "Prossima": 1,
  "Prossimità": 1,
  "Realestate": 1,
  "Relazioni": 1,
  "Reverberi": 1,
  "Rhapsody": 1,
  "Riapre": 1,
  "Ricatto": 1,
  "Ricordo": 1,
  "Rimozione": 1,
  "Rinascita": 1,
  "Risparmi": 1,
  "Risparmiare": 1,
  "Risparmio": 1,
  "Ritratti": 1,
  "Rotta": 1,
  "Russo": 1,
  "Sbandati": 1,
  "Scacchi": 1,
  "Scelte": 1,
  "Scuola": 1,
  "Semplificazioni": 1,
  "Serve": 1,
  "Smart": 1,
  "Sospeso": 1,
  "Specchio": 1,
  "Sportiva": 1,
  "Stangati": 1,
  "Stasera": 1,
  "Storie": 1,
  "Stories": 1,
  "Story": 1,
  "Stress": 1,
  "Tariffe": 1,
  "Tarip": 1,
  "Tasse": 1,
  "Tesoro": 1,
  "Therapy": 1,
  "Tokyo": 1,
  "Ucraina": 1,
  "Uso": 1,
  "Vacanze": 1,
  "Varsavia": 1,
  "Vetrine": 1,
  "Vita": 1,
  "Voci": 1,
  "Working": 1
}
